import gql from 'graphql-tag';

export const UPSERT_PARTNER_PROFILE = gql`
  mutation UpsertPartnerProfile($input: UpsertPartnerProfileInput!) {
    result: upsertPartnerProfile(input: $input) {
      id
    }
  }
`;
